define('app/editor/SegmentPage',['require','app/app','./ReportPage','./dialogs/SaveSegmentDialogView','glu/dialog','glu/$','hbs!./SegmentPage.hbs'],function(require) {
	'use strict';

	var App = require('app/app'),
		ReportPage = require('./ReportPage'),
		SaveSegmentDialogView = require('./dialogs/SaveSegmentDialogView'),
		Dialog = require('glu/dialog'),
		$ = require('glu/$');

	var noDesc = '(No description)';

	return ReportPage.extend({

		className: 'page-report',

		dialog: Dialog,

		template: require('hbs!./SegmentPage.hbs'),

		isOwner: function() {
			return this.options.segment.isOwner();
		},

		reportName: function() {
			return this.options.segment.getName();
		},

		refreshClassesAndStates: function() {
			var self = this;

			self.$el.toggleClass('is-grouping-hidden', !self.model.isGroupedAndAggregated());
			self.$el.toggleClass('no-columns', self.model.hasNoColumns());

			var $defineView = self.$el.find('.define-view');
			$defineView.toggleClass('is-runnable', self.model.isRunnable());
			$defineView.toggleClass('is-not-runnable', self.model.isNotRunnable());
			$defineView.toggleClass('has-rows', self.model.hasGroupColumns());
			$defineView.toggleClass('has-no-columns', self.model.hasNoColumns());

			// Toggle report action options
			if (self.model.isSaved()) {
				self.$el.find('.report-options-more').show();
				self.$el.find('.report-save-button').show();
				self.$el.find('.report-save-button').removeClass('menu-hidden');

				if (self.model.isOwner()) {
					if (self.model.isDirty && self.model.isDirty() && self.model.isRunnable() && self.model.canRenderReport()) {
						self.$el.find('.report-save-button').removeClass('disabled');
						self.$el.find('.report-export-button').removeClass('disabled');
						self.$el.find('.report-save-button').html('Save');
					} else {
						self.$el.find('.report-save-button').addClass('disabled');
						self.$el.find('.report-export-button').removeClass('disabled');
						self.$el.find('.report-save-button').html('Saved');
					}
				}
			} else {
				self.$el.find('.report-options-more').hide();
				self.$el.find('.report-save-button').show();
				self.$el.find('.report-save-button').addClass('menu-hidden');

				if (self.model.isDirty() && self.model.isRunnable() && self.model.canRenderReport()) {
					self.$el.find('.report-save-button').removeClass('disabled');
					self.$el.find('.report-save-button').html('Save');
				}


				self.$el.find('.report-set-alert').addClass('disabled');
				self.$el.find('.alert-item').addClass('disabled');
				self.$el.find('.report-save-as-a-metric').addClass('disabled');

				if (!self.model.get('description') || self.model.get('description') === '' || self.model.get('description') === noDesc) {
					$('.description span').text(noDesc);
					$('.description span').addClass('no-desc');
				} else {
					$('.description span').text(self.model.get('description'));
					$('.description span').removeClass('no-desc');
				}
			}
		},

		save: function(e) {
			var self = this;
			var report = self.model;
			var segment = self.options.segment;

			e.preventDefault();

			// Save is not allowed for internal users
			if (App.user.isInternalUser()) {
				return;
			}

			if ((this.model.isDirty() || !self.model.isSaved() || !self.model.isOwner()) && this.model.isValid() && this.model.canRenderReport()) {
				if (this.model.isSaved() && self.model.isOwner()) {

					var msg = 'Please note that any changes to this segment will also reflect the changes in all monitors that use this segment. Are you sure you want to continue?';
					var caption = 'Save segment';

					Dialog.confirm(msg, caption, function(ok) {
						if (ok) {
							self.model.set('saveInProgress', true, {
								silent: true
							});

							if (self.model.getDescription() === noDesc) {
								self.model.set('description', '', {
									silent: true
								});
							}

							// set name
							segment.setName(report.getName());

							// set description
							segment.setDescription(report.getDescription());

							// set filters
							segment.set('filters', report.get('filter'));

							// save segment
							segment.save().then(function() {
								self.model.set('saveInProgress', false, {
									silent: true
								});
								report.getDomain().trigger('segment:reload');
								self.model.clean();

								self.refreshClassesAndStates();
							});
						}
					});

				} else {
					this.saveAs(e);
				}
			}
		},

		saveAs: function(e) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			var report = self.model;
			var segment = self.options.segment.clone();

			// reset Id, so its a new segment
			segment.setId(null);

			// set filters
			segment.set('filters', report.get('filter'));

			if (self.model.isRunnable()) {
				this.dialog.open(new SaveSegmentDialogView({
					model: segment,
					saveAs: true
				}));
			}
		},

		delete: function(e) {
			var self = this;
			var cid = self.model.cid;
			var segment = self.options.segment;

			e.preventDefault();

			var msg = 'Are you sure you want to delete this segment?';
			var caption = 'Delete segment';

			Dialog.confirm(msg, caption, function(ok) {
				if (ok) {
					segment.delete().then(function() {
						App.openReports.remove(cid);
						self.navigateTo('/dashboard');
					}, function(data) {
						if (data && data.responseJSON) {
							if (data.responseJSON.errorCode !== 'UNKNOWN_EXCEPTION') {
								Dialog.alert(data.responseJSON.errorMessage, 'An error occurred');
							} else {
								Dialog.alert('An error occurred while processing your request. Please contact your local administrator.', 'An error occurred');
							}
						}
					});
				}
			});
		},
		hasDashboard: function() {
			return true;
		},

		getDashboardName: function() {
			return 'Segments';
		}
	});

});

